import { render } from "./AddProjectCategoryModal.vue?vue&type=template&id=b1901dec"
import script from "./AddProjectCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddProjectCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__